import React from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';
import AvatarUser from 'Demand/components/AvatarUser';

export const ContactDetails = props => {
  return (
    <Grid
      item
      // lg={4}
      // md={6}
      xs={12}
      // className="border-bottom-light-gray-2"
    >
      {props.contactDetails && (
        <Grid container>
          <Grid
            item
            // lg={4}
            // md={6}
            xs={6}
            className=""
          >
            <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">
              Supplier contact details
            </h2>
          </Grid>
          <Grid container className="t-primary-1">
            <Grid
              item
              // lg={4}
              md={6}
              xs={12}
              className="no-padding"
            >
              {props.contactDetails.manufacturer && (
                <Grid container spacing={0} className="u-mrg-5">
                  <Grid
                    item
                    // lg={4}
                    // md={6}
                    xs={4}
                    className="t-primary-12 t-weight-b criteria-name"
                  >
                    Manufacturer:
                  </Grid>
                  <Grid
                    item
                    // lg={4}
                    // md={6}
                    xs={8}
                    className="t-primary-14 c-gray-light criteria-description  c-gray-light"
                  >
                    <span>{props.contactDetails.manufacturer}</span>
                  </Grid>
                </Grid>
              )}
              {props.contactDetails.contact && (
                <Grid container spacing={0} className="u-mrg-5">
                  <Grid
                    item
                    // lg={4}
                    // md={6}
                    xs={4}
                    className="t-primary-12 t-weight-b criteria-name"
                  >
                    Contact:
                  </Grid>
                  <Grid
                    item
                    // lg={4}
                    // md={6}
                    xs={8}
                    className="t-primary-14 c-gray-light criteria-description c-gray-light"
                  >
                    <span>{props.contactDetails.contact}</span>
                  </Grid>
                </Grid>
              )}
              {props.contactDetails.email && (
                <Grid container spacing={0} className="u-mrg-5">
                  <Grid
                    item
                    // lg={4}
                    // md={6}
                    xs={4}
                    className="t-primary-12 t-weight-b criteria-name"
                  >
                    Email:
                  </Grid>
                  <Grid
                    item
                    // lg={4}
                    // md={6}
                    xs={8}
                    className="t-primary-14 c-gray-light criteria-description c-gray-light"
                  >
                    <span>{props.contactDetails.email}</span>
                  </Grid>
                </Grid>
              )}
              {props.contactDetails.mobile && (
                <Grid container spacing={0} className="u-mrg-5">
                  <Grid
                    item
                    // lg={4}
                    // md={6}
                    xs={4}
                    className="t-primary-12 t-weight-b criteria-name"
                  >
                    Phone:
                  </Grid>
                  <Grid
                    item
                    // lg={4}
                    // md={6}
                    xs={8}
                    className="t-primary-14 c-gray-light criteria-description c-gray-light"
                  >
                    <span>{props.contactDetails.mobile}</span>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <AvatarUser />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
